import { useContext, useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { IFormCategories } from '../../../../Pages/Cadastro/cadCategorias';
import Layout from '../../../data/Layout';
import { InputDefault } from '../../../data/inputDefault';
import ReactSelect from '../../../data/reactSelect';
import { notifyError } from '../../../notify/notify-component';
import { Printers } from '../Impressoras';
import { CategoryContext } from '../../../../context/category';
import globals from '../../../../Globals.json';
import { useAppSelector } from '../../../../redux/store';
import { InfoSales } from '../InfoVenda';
import * as S from './styled';
import InputImg from '../../../data/inputImg';
import type { ICategorie } from '../../../../redux/features/inventary/interface';
import { ConfigProducts } from '../config';
import Complements from './Complements';
import Associated from './Associados';
import Loading from '../../../Loading/Loading';
import { useCreateData } from '../../../../apiQuery/useCreateData';
import { useQueryClient } from '@tanstack/react-query';
import { useQueryFetchPages } from '../../../../apiQuery/useQueryFetchPages';
import { useUpdateData } from '../../../../apiQuery/useUpdateData';
import { queryClient } from '../../../../apiQuery/queryClient';
import { useFetchById } from '../../../../apiQuery/useFetchById';

export default function FormCategories({
  OnAddNewCategorie,
  categories,
  title,
  editando,
}: IFormCategories) {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);
  const createData = useCreateData(['category']);
  const updateData = useUpdateData(['category']);
  const {
    setLoading,
    xdFollowItem,
    xdPrinters,
    nomeCategoria,
    setNomeCategoria,
    nomeSubcategoria,
    setNomeSubcategoria,
    perfilFiscal,
    setPerfilFiscal,
    listaPerfilFiscal,
    nomeCategoriaInValid,
    nomelistalistaPerfilFiscalInValid,
    clearFilds,
    handleValidete,
    handleEdit,
    selfService,
    image,
    setImage,
    order,
    setOrder,
    visible_falimix,
    visible_autoplu,
    visible_delivery,
    visible_xd_orders,
    visible_online,
    visible_digital_menu,
    xdRequestQty,
    xdRequestPriceWhenZero,
    xdBalanceQty,
    xdOrderGrouped,
    xdBillGroup,
    xdAddTips,
    xdExcludeMinimumConsumption,
    xdBook,
    associatedComplement,
    categoriesList,
    loading,
    status,
    setStatus,
  } = useContext(CategoryContext);
  const [key, setKey] = useState('info-sales');
  const {
    data: categoryByUuid,
    isLoading: isLoadingCategoryById,
    isError: isErrorCategoryById,
  } = useFetchById<any>(
    'category',
    `${globals.api.categoriesCompleted}`,
    categories?.uuid,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
      },
    }
  );
  // Query otimizada usando endpoint específica para categorias pai (mais leve)
  const { data: listaSubCategoria, isLoading: listaSubCategoriaIsLoading } =
    useQueryFetchPages<any>(['parentCategories'], `${globals.api.categoriesCompleted}/parent-categories`, {
      queryParams: { 
        store_id: storeMe?.storeActive?.id
      },
    });

  const { data: listaTaxProfile, isLoading: listaTaxProfileIsLoading } =
    useQueryFetchPages<any>(['taxProfile'], globals.api.taxProfile, {
      queryParams: { paginate: false, store_id: storeMe?.storeActive?.id },
    });

  function handleSubmit() {
    const valid = handleValidete();

    if (!valid) {
      notifyError('Por favor preencha todos os campos obrigatórios..');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const oModel = {
      uuid: categories?.uuid ? categories.uuid : null,
      store_id: storeMe?.storeActive?.id,
      sort_category: order,
      name: nomeCategoria,
      ...(nomeSubcategoria && { parent_id: nomeSubcategoria }),
      tax_profile_id: perfilFiscal,
      xd_printers: xdPrinters,
      xd_follow_item: xdFollowItem,
      xd_request_qty: xdRequestQty,
      xd_request_price_when_zero: xdRequestPriceWhenZero,
      xd_balance_qty: xdBalanceQty,
      xd_order_grouped: xdOrderGrouped,
      xd_bill_group: xdBillGroup,
      xd_add_tips: xdAddTips,
      xd_exclude_minimum_consumption: xdExcludeMinimumConsumption,
      xd_book: xdBook,
      visible_falimix,
      visible_autoplu,
      visible_delivery,
      visible_digital_menu,
      visible_online,
      visible_xd_orders,
      product_complements: completmentProduct(categoriesList),
      product_associateds: completmentProduct(associatedComplement),
      self_service: selfService,
      is_active: status,
      ...(image !== categories?.image && {
        image: image === '' ? null : image,
      }),
    };

    setLoading(true);
    if (oModel.uuid) {
      updateData.mutate(
        {
          endpoint: globals.api.categoriesAlt,
          id: oModel.uuid,
          payload: oModel,
        },
        {
          onSuccess: () => {
            handleCancel();
            queryClient.invalidateQueries({
              predicate: (query) => query.queryKey[0] === 'category',
            });

            setLoading(false);
          },
          onError: () => {
            setLoading(false);
          },
        }
      );
    } else {
      createData.mutate(
        {
          endpoint: globals.api.categoriesAlt,
          payload: oModel,
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({
              predicate: (query) => query.queryKey[0] === 'category',
            });
            setLoading(false);
            handleCancel();
          },
          onError: () => {
            setLoading(false);
          },
        }
      );
    }
  }

  function handleCancel() {
    clearFilds();
    OnAddNewCategorie(false);
  }

  const completmentProduct = (list: any) => {
    const newList = [];
    for (let index = 0; index < list?.length; index++) {
      newList.push({
        product_id: list[index].id,
      });
    }
    return newList;
  };

  useEffect(() => {
    editando && categoryByUuid && handleEdit(categoryByUuid?.data);
  }, [categoryByUuid]);

  // Exibe loading apenas se a categoria principal ainda está carregando (em modo de edição)
  // ou se é uma nova categoria e as requisições essenciais ainda não terminaram
  if (editando && isLoadingCategoryById) {
    return <Loading />;
  }
  
  // Para nova categoria, aguarda apenas as requisições essenciais
  if (!editando && (listaSubCategoriaIsLoading || listaTaxProfileIsLoading)) {
    return <Loading />;
  }

  const listaSubCategoriaRemoveChildren = listaSubCategoria?.data?.filter(
    (item: ICategorie) => item.uuid !== categories?.uuid
  );

  const bg = status ? '#16a34a' : '#f87171';

  return (
    <>
      <Layout
        title={title}
        isEditable={editando}
        onClickSave={handleSubmit}
        onClickEdit={handleSubmit}
        onClickCancel={handleCancel}
        loading={loading}
      >
        <S.WrapperStatus>
          <button
            type="button"
            onClick={() => setStatus(!status)}
            style={{ background: bg }}
          >
            {status ? 'Ativo' : 'Inativo'}
          </button>
        </S.WrapperStatus>
        <S.Content>
          <S.WrapperImg>
            <InputImg state={image} setState={setImage} />
          </S.WrapperImg>
          <S.Wrapper>
            <InputDefault
              label="Ordem"
              type="text"
              autoComplete="off"
              state={order}
              placeholder="Ordem"
              maxLength={50}
              isInvalid={nomeCategoriaInValid}
              setState={setOrder}
            />
            <InputDefault
              label="Categoria"
              type="text"
              autoComplete="off"
              state={nomeCategoria}
              placeholder="Nome da categoria"
              maxLength={50}
              isInvalid={nomeCategoriaInValid}
              setState={setNomeCategoria}
            />

            <ReactSelect
              label="Subcategoria"
              isClearable={true}
              placeholder={'Subcategoria de'}
              options={listaSubCategoriaRemoveChildren?.map((item: any) => ({
                ...item,
                value: item.id_pdv_category,
                label: item.name,
                store_id: item.store_id,
              }))}
              state={nomeSubcategoria}
              setState={setNomeSubcategoria}
              isLoading={listaSubCategoriaIsLoading}
              //isInvalid={nomelistaSubCategoriaInValid}
            />

            <ReactSelect
              label="Perfil fiscal"
              isClearable={true}
              placeholder={'Associar Perfil fiscal'}
              options={listaTaxProfile?.data?.map((item: any) => ({
                value: item.id,
                label: item.tax_profile_name,
                store_id: item.store_id,
              }))}
              state={perfilFiscal}
              setState={setPerfilFiscal}
              isInvalid={nomelistalistaPerfilFiscalInValid}
              isLoading={listaTaxProfileIsLoading}
            />
          </S.Wrapper>
        </S.Content>

        <Tabs
          defaultActiveKey="personData"
          className="mt-2"
          activeKey={key}
          onSelect={(k: any) => setKey(k)}
        >
          <Tab eventKey="info-sales" title="Informações de Venda">
            <InfoSales />
          </Tab>
          <Tab eventKey="config" title="Configurações">
            <ConfigProducts />
          </Tab>
          <Tab eventKey="print" title="Impressoras">
            <Printers />
          </Tab>
          <Tab eventKey="complement" title="Observações">
            <Complements isEditable={editando} />
          </Tab>
          <Tab
            eventKey="A
                       associated"
            title="Extras"
          >
            <Associated isEditable={editando} />
          </Tab>
        </Tabs>
      </Layout>
    </>
  );
}
